import { render, staticRenderFns } from "./EditChkSpecPat.vue?vue&type=template&id=148f1b4a&scoped=true"
import script from "./EditChkSpecPat.vue?vue&type=script&lang=js"
export * from "./EditChkSpecPat.vue?vue&type=script&lang=js"
import style0 from "./EditChkSpecPat.vue?vue&type=style&index=0&id=148f1b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f1b4a",
  null
  
)

export default component.exports